import { ArrowLeftIcon, ArrowRightIcon, Button } from "@datagame/ui";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames/bind";

import { GameList } from "./GameList";
import { Step } from "../ProjectView";
import { Step as StepComponent } from "./Step";
import { useStep } from "../../../../contexts/step/StepContext";

import styles from "./ProjectNavigation.module.scss";

const cx = classNames.bind(styles);

interface ProjectNavigationProps {
  steps: Step[];
}

export const ProjectNavigation = ({ steps }: ProjectNavigationProps) => {
  const { currentStep, setCurrentStep } = useStep();
  const { t } = useTranslation("project");

  const activeStepRef = useRef<HTMLDivElement>(null);

  const hasGameList = currentStep > 1;

  useEffect(() => {
    if (activeStepRef?.current) {
      activeStepRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [currentStep]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.stepsList}>
        {steps.map((step, index) => {
          const isActive = index <= currentStep - 1;
          const isCurrentStep = index === currentStep - 1;

          return (
            <div key={index} ref={isCurrentStep ? activeStepRef : undefined} className={styles.stepWrapper}>
              <StepComponent
                title={step.title}
                icon={step.icon}
                step={index}
                isActive={isActive}
                onClick={() => setCurrentStep(index + 1)}
              />
            </div>
          );
        })}
      </div>
      <div className={cx("bottomBar", { hasGameList })}>
        {hasGameList && <GameList />}

        <div className={styles.buttons}>
          <Button
            kind="outline"
            iconSide="left"
            icon={<ArrowLeftIcon />}
            onClick={() => setCurrentStep(currentStep - 1)}
          >
            {t("navigation.controls.back")}
          </Button>
          <Button iconSide="left" icon={<ArrowRightIcon />} onClick={() => setCurrentStep(currentStep + 1)}>
            {t("navigation.controls.next")}
          </Button>
        </div>
      </div>
    </div>
  );
};
